<template>
    <div class="button-container" :class="{padded, tabInline,disabled,running}">
        <button class="button" :class="[color]" @click="$emit('click', $event)">
            <div class="text">
                <div class="icon" v-if="icon">
                    <awesome-icon :icon="icon"></awesome-icon>
                </div>
                <slot></slot>
            </div>
            <fade-in-transition>
                <div class="running" :class="[color]" v-if="running"></div>
            </fade-in-transition>
        </button>
    </div>
</template>

<script>
export default {
  name: "sc-button",
  props: {
    color: {},
    running: {},
    padded: {
      type: Boolean,
      default: false,
    },
    tabInline: {
      type: Boolean,
      default: false,
    },
    icon: {},
    disabled: {
      type: Boolean,
      default: false,
    },
  }

}
</script>

<style scoped lang="scss">
button {
    font-size: inherit;
}

.button-container.padded {
    margin-right: 32px;
}

.button {
    border: none;
    //border-radius: 5px;
    padding: 12px 16px 12px 16px;
    background: $color-primary;
    color: #fff;
    box-sizing: border-box;

    cursor: pointer;
    position: relative;
    display: inline-block;
    outline: none;
    overflow: hidden;
    margin: 0;
}

.button:hover {

}

.tabInline .button {
    /*padding-top: 14px;*/
    /*padding-bottom: 14px;*/
}

.button.secondary {
    background: $color-primary;
    color: #fff;
    box-shadow: $shading;
}

.button.secondary:hover {
    background: #e2e2e2;
}

.button.dark {
    background: $color-secondary;
    color: #fff;
}

.button:active {
    transform: translateY(1px);
    // box-shadow: 1px 2px 4px 1px rgba(0, 0, 0, 0.05);
    // box-shadow: 1px 1px 0px 0px rgba(200, 0, 0, 0.1), $shading;
}

.button .text {
    //font-family: Montserrat, sans-serif;
    font-weight: 600;
    //text-transform: uppercase;
    font-size: 0.9em;
    user-select: none;
    display: flex;
    align-items: center;
}

.button .icon {
    width: 1.4em;
    text-align: left;
}

.disabled,
.running {
    opacity: .5;
    color: #111;
    pointer-events: none;
}

.button.secondary.running {
    color: #ddd;
}

.running:after {
    background-color: rgba(250, 0, 0, 0.1);
}

.secondary.running:after {
    background-color: rgba(250, 255, 255, 0.3);
}

</style>